import { render } from "./GameList.vue?vue&type=template&id=05143450"
import script from "./GameList.vue?vue&type=script&lang=js"
export * from "./GameList.vue?vue&type=script&lang=js"
script.render = render

export default script